var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup42(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 16,
    viewBox: "0 0 28 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 7.92453L16.1132 14.7874L16.1132 1.06169L28 7.92453Z",
    fill: "#C14A4A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 5.28302,
    width: 17.9623,
    height: 4.75472,
    fill: "#C14A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup42);
export default __webpack_public_path__ + "static/media/Group-42.b8bbbb9970002ecbfa44c18c3b7619d2.svg";
export { ForwardRef as ReactComponent };